import React from 'react';

/* ============================================================
   KGOB coffee illustrations — pure SVG, brand teal/navy/gold.
   Ported from the design handoff (Kgob coffee page redesign).
   ============================================================ */

// Teal mug with heart latte-art foam + saucer. Optional rising steam.
export function TealMug({ size = 130, showSteam = false }) {
  return (
    <div style={{ position: 'relative', width: size }}>
      {showSteam && (
        <svg
          style={{ position: 'absolute', left: size * 0.3, top: -size * 0.2 }}
          width={size * 0.43} height={size * 0.35} viewBox="0 0 56 46"
          fill="none" stroke="#9FC9D2" strokeWidth="4" strokeLinecap="round"
        >
          <path d="M16 42 Q9 30 16 20 Q23 12 16 4" style={{ animation: 'kg-steam 3.2s ease-in-out infinite' }} />
          <path d="M32 42 Q25 30 32 20 Q39 12 32 4" style={{ animation: 'kg-steam 3.2s ease-in-out infinite .9s' }} />
        </svg>
      )}
      <svg width={size} height={size * 0.985} viewBox="0 0 124 124" fill="none">
        <ellipse cx="58" cy="113" rx="44" ry="8" fill="#1B3A5C" opacity=".10" />
        <ellipse cx="58" cy="107" rx="44" ry="9" fill="#E2D4B6" />
        <ellipse cx="58" cy="104" rx="44" ry="8.5" fill="#F4ECD8" />
        <path d="M90 60 q26 2 24 22 q-2 18 -26 16" stroke="#1AA0B8" strokeWidth="11" fill="none" strokeLinecap="round" />
        <path d="M90 62 q20 2 18 18 q-2 13 -20 12" stroke="#43B8CE" strokeWidth="4" fill="none" strokeLinecap="round" opacity=".6" />
        <path d="M24 50 L96 50 L90 86 Q86 100 60 100 Q34 100 30 86 Z" fill="#1AA0B8" />
        <path d="M24 50 L96 50 L93 66 Q60 76 27 66 Z" fill="#21ABC2" />
        <ellipse cx="60" cy="50" rx="36" ry="9" fill="#36B4CA" />
        <ellipse cx="60" cy="49" rx="28" ry="6.4" fill="#6E4226" />
        <ellipse cx="60" cy="48" rx="28" ry="6" fill="#7A4A28" />
        <path d="M60 42.5 C56.5 37.5 48.5 38 48.5 44 C48.5 49 55.5 52 60 55 C64.5 52 71.5 49 71.5 44 C71.5 38 63.5 37.5 60 42.5 Z" fill="#F3E7CF" />
      </svg>
    </div>
  );
}

// White/cream to-go cup with teal "KG" sleeve + navy lid.
export function ToGoCup({ size = 92 }) {
  return (
    <svg width={size} height={size * 1.26} viewBox="0 0 84 110" fill="none">
      <ellipse cx="42" cy="106" rx="26" ry="5" fill="#1B3A5C" opacity=".10" />
      <path d="M20 38 L64 38 L58 100 Q57.5 104 53 104 L31 104 Q26.5 104 26 100 Z" fill="#F4ECDC" />
      <path d="M20 38 L64 38 L62.5 54 L21.5 54 Z" fill="#E7DBC2" />
      <path d="M22.5 62 L61.5 62 L59.5 86 L24.5 86 Z" fill="#1AA0B8" />
      <text x="42" y="80" textAnchor="middle" fontFamily="Poppins" fontWeight="800" fontSize="15" fill="#fff" letterSpacing="-1.5">KG</text>
      <rect x="16" y="28" width="52" height="12" rx="4" fill="#15324F" />
      <path d="M21 28 Q42 17 63 28 Z" fill="#1B3A5C" />
      <rect x="38" y="13" width="9" height="9" rx="2" fill="#1B3A5C" />
    </svg>
  );
}

export function Bean({ w = 34 }) {
  return (
    <svg width={w} height={w * 0.7} viewBox="0 0 34 24">
      <ellipse cx="17" cy="12" rx="16" ry="10.5" fill="#5B3A24" />
      <path d="M9 4 Q19 12 25 20" stroke="#3A2414" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    </svg>
  );
}

export function Sparkle({ size = 22, color = '#1AA0B8' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 22 22">
      <path d="M11 1 L13 9 L21 11 L13 13 L11 21 L9 13 L1 11 L9 9 Z" fill={color} />
    </svg>
  );
}

export function Heart({ size = 26, color = '#1AA0B8', opacity = 0.85 }) {
  return (
    <svg width={size} height={size * 0.92} viewBox="0 0 24 22">
      <path d="M12 21 C12 21 1 14 1 7 C1 3 4 1 7 1 C9.5 1 11 2.5 12 4 C13 2.5 14.5 1 17 1 C20 1 23 3 23 7 C23 14 12 21 12 21 Z" fill={color} opacity={opacity} />
    </svg>
  );
}

export function Sprig({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" stroke="#1AA0B8" strokeWidth="2" strokeLinecap="round">
      <path d="M6 34 Q20 24 34 8" />
      <path d="M16 24 Q14 18 8 18" />
      <path d="M22 18 Q22 12 28 12" />
    </svg>
  );
}

// Small cup variants used in the "Pick your brew" cards.
export function BrewCup({ type }) {
  switch (type) {
    case 'black':
      return (
        <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
          <path d="M14 24 L50 24 L46 44 Q44 52 32 52 Q20 52 18 44 Z" fill="#1B3A5C" />
          <path d="M48 28 q12 1 11 11 q-1 9 -12 8" stroke="#1B3A5C" strokeWidth="5" fill="none" strokeLinecap="round" />
          <ellipse cx="32" cy="24" rx="18" ry="4.5" fill="#2A4A6B" />
          <ellipse cx="32" cy="23.5" rx="13" ry="3" fill="#3A2414" />
        </svg>
      );
    case 'cappuccino':
      return (
        <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
          <path d="M14 27 L50 27 L46 46 Q44 53 32 53 Q20 53 18 46 Z" fill="#1AA0B8" />
          <path d="M48 31 q12 1 11 11 q-1 9 -12 8" stroke="#1AA0B8" strokeWidth="5" fill="none" strokeLinecap="round" />
          <ellipse cx="32" cy="27" rx="18" ry="5" fill="#36B4CA" />
          <path d="M15 26 Q32 13 49 26 Q49 29 32 31 Q15 29 15 26 Z" fill="#F3E7CF" />
        </svg>
      );
    case 'latte':
      return (
        <svg width="56" height="60" viewBox="0 0 64 64" fill="none">
          <path d="M22 14 L46 14 L43 52 Q42.5 55 39 55 L29 55 Q25.5 55 25 52 Z" fill="#F4ECDC" opacity=".5" />
          <path d="M24.4 31 L44 31 L43 52 Q42.5 55 39 55 L29 55 Q25.5 55 25 52 Z" fill="#7A4A28" />
          <path d="M23.6 25 L44.6 25 L44 31 L24.2 31 Z" fill="#C99B6A" />
          <path d="M22.8 16 L45.2 16 L44.6 22 L23.4 22 Z" fill="#F3E7CF" />
          <ellipse cx="34" cy="14" rx="12" ry="3" fill="#FBF6EC" />
        </svg>
      );
    case 'affogato':
      return (
        <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
          <path d="M16 31 L48 31 L45 48 Q43 54 32 54 Q21 54 19 48 Z" fill="#1B3A5C" />
          <path d="M46 34 q11 1 10 10 q-1 8 -11 7" stroke="#1B3A5C" strokeWidth="5" fill="none" strokeLinecap="round" />
          <ellipse cx="32" cy="31" rx="16" ry="4.5" fill="#2A4A6B" />
          <circle cx="32" cy="24" r="11" fill="#F3E7CF" />
          <circle cx="32" cy="24" r="11" fill="none" stroke="#E6D4B0" strokeWidth="1.5" />
          <path d="M30 14 q2 4 2 6 q0 -2 2 -6" fill="#C9A23F" />
        </svg>
      );
    default:
      return null;
  }
}

// Steaming check badge used on the success screen.
export function SuccessMug() {
  return (
    <div style={{ position: 'relative', width: 120, margin: '4px auto 20px', animation: 'kg-pop .5s ease-out both' }}>
      <svg style={{ position: 'absolute', left: 36, top: -22 }} width="50" height="40" viewBox="0 0 50 40" fill="none" stroke="#BBD9E0" strokeWidth="3.6" strokeLinecap="round">
        <path d="M14 36 Q8 26 14 17 Q20 10 14 3" style={{ animation: 'kg-steam 3s ease-in-out infinite' }} />
        <path d="M30 36 Q24 26 30 17 Q36 10 30 3" style={{ animation: 'kg-steam 3s ease-in-out infinite .8s' }} />
      </svg>
      <TealMug size={120} />
      <div style={{ position: 'absolute', right: 6, bottom: 8, width: 38, height: 38, borderRadius: '50%', background: '#C9A23F', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(201,162,63,.5)', border: '3px solid #fff' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A5C" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round"><path d="M5 13l4 4 10-11" /></svg>
      </div>
    </div>
  );
}
